import React, { useState } from 'react';
import { Input } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const editarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalCancelacion = (props)=>{
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [observacion, setObservacion]= useState('')
    const [cancelando, setCancelando] = useState(false)

    const cambioEstadoEnDB = async () => {
        try {
            let body = {
                cod_soli: props.data.codigoAPE,
                cod_empr: userData.codigoEmpresa,
                data: {
                    cmp_stat: 'CANCELADA',
                }
            }
            await editarAPE(body)
            props.toastSuccess('Solicitud Cancelada')
        }
        catch (error) {
            props.toastError('Error al cancelar!')
            console.log(error)
        }
    }

    const cancelarSolicitud =()=>{
        try {
            setCancelando(true)
            cambioEstadoEnDB()
            props.action()
            setCancelando(false)
            props.toggle()
        }
        catch (error) {
            console.log(error)
        }
        
    }
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Cancelar Solicitud'}
                buttonTitle={'Cancelar'}
                onClick={() => cancelarSolicitud()}
                buttonLoading={cancelando}
            >
                <Input type="textarea" name="input_observacionCancelacion" defaultValue={observacion} onChange={(e) => setObservacion(e.target.value)} id="observacionCancelacion" />
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalCancelacion);